import { clsx } from 'clsx'
import { type FC } from 'react'

import { PrescriptionPrescriptionTypeEnum } from '@redteclab/api/clients/bully'
import { type CrossSellProduct } from '@redteclab/api/clients/retail-media-xsell-service'
import { IconShoppingCart } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useProductAddToCart } from '../../hooks/useProductAddToCart'

export const CartIntermediateSpecialOffersBuyProductButton: FC<{
  className?: string
  product?: CrossSellProduct
}> = ({ className, product }) => {
  const sellerData = product
    ? {
        sellerId: product.sellerId,
        sellerName: product.sellerName,
      }
    : undefined

  const { handleAddToCart } = useProductAddToCart({
    currentPrescriptionType: PrescriptionPrescriptionTypeEnum.NoPrescription,
    offerId: product?.offerId ?? '',
    product,
    quantity: 1,
    redpoints: Number(product?.redpoints ?? 0),
    sellerData,
  })

  return (
    <Button
      className={clsx('text-xl', className)}
      onClick={(): void => {
        void handleAddToCart()
      }}
      size="small"
    >
      <IconShoppingCart />
    </Button>
  )
}
